import { inject } from "@angular/core";
import { LoggerService } from "@app/core/logger";
import { TenantConfig, TenantService } from "./tenant.service";
import { environment } from "@app/environments/environment";

export const initTenantConfig = async () => {
  const tenantService = inject(TenantService);
  const tenantCode = environment.TENANT_CODE;
  const logger = inject(LoggerService);

  logger.debug(`Tenant Code: ${tenantCode}`);

  return fetch(`assets/config/tenant-configs/${tenantCode}.json`)
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Failed to load tenant config: ${response.status} ${response.statusText}`
        );
      }
      return response.json();
    })
    .then((jsonData: TenantConfig) => {
      tenantService.initTenant(jsonData);
      return jsonData;
    })
    .catch((error) => {
      logger.error("Error loading tenant config:", error);
      throw error;
    });
};

export default initTenantConfig;
